<template>
  <span>
    <permissions-group-new
      v-if="adding"
      @cancel="cancelAdding"
      @added="permissionsGroupAdded"
    />

    <permissions-group-edit
      v-else-if="editing"
      :permissions-group-data="selectedPermissionsGroupData"
      @cancel="cancelEditing"
      @edited="permissionsGroupEdited"
      @editError="editPermissionsGroupError"
    />

    <v-layout
      v-else-if="loading"
      justify-center
      align-center
      class="loading-indicator"
    >
      <v-progress-circular
        indeterminate
        :size="70"
        :width="7"
      />
    </v-layout>

    <v-card
      v-show="!adding && !editing && !firstLoading"
      class="groups-card"
    >
      <v-card-title
        v-if="showSuccessMsg"
        class="success-message"
        :class="{ 'success-message-hide': !showSuccess}"
      >
        <div class="headline success-message-text"><i class="far fa-check-circle" />Группа прав добавлена</div>
      </v-card-title>

      <v-card-title
        v-if="showErrorMsg"
        class="error-message"
        :class="{ 'error-message-hide': !showError}"
      >
        <div class="headline success-message-text"><i class="far fa-times-circle" /> {{ errorMsg }}</div>
      </v-card-title>
      <v-btn
        fab
        color="primary"
        @click="addPermissionsGroup"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="serverItemsLength"
        fixed-header=""
        no-data-text="Нет данных для отображения"
        :footer-props="{
          itemsPerPageText: 'Число групп на странице',
          itemsPerPageOptions: [25, 50]
        }"
        dense
      >
        <tr
          slot="item"
          slot-scope="props"
        >
          <td>{{ props.item.name }}</td>
          <td class="justify-center px-0">
            <span class="action-btns">
              <v-btn
                icon
                class="mt-1"
                title="Редактировать"
                @click="editPermissionsGroup(props.item)"
              >
                <v-icon color="grey">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mt-1"
                title="Удалить"
                @click="deletePermissionsGroup(props.item)"
              >
                <v-icon color="red">delete</v-icon>
              </v-btn>
            </span>
          </td>
        </tr>
      </v-data-table>
    </v-card>
  </span>
</template>

<script>
const API_URL = 'permissions_groups'
import PermissionsGroupNew from './PermissionsGroupNew.vue'
import PermissionsGroupEdit from './PermissionsGroupEdit.vue'
export default {
  name: 'PermissionsGroups',
  components: {
    PermissionsGroupNew,
    PermissionsGroupEdit
  },
  data () {
    return {
      search: '',
      items: [],
      firstLoading: true,
      loading: true,
      options: { page: 1, itemsPerPage: 25 },
      serverItemsLength: 0,
      headers: [
        {
          text: 'Наименование',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: '',
          align: 'right',
          sortable: false,
          value: 'actions'
        }
      ],
      adding: false,
      showSuccess: false,
      showSuccessMsg: false,
      editing: false,
      selectedPermissionsGroupData: {},
      showErrorMsg: false,
      showError: false,
      errorMsg: null,
      getTimer: '',
      searchTimer: '',
      deleteTimer: ''
    }
  },
  watch: {
    options: {
      handler () {
        this.getPermissionsGroupsApiTimer()
      },
      deep: true
    },
    search () {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.options.page = 1
        this.getPermissionsGroupsApiTimer()
      }, 500)
    },
    'editedTaskItem.counter_parameters': function () {
      if (this.sendUpdate) {
        return
      }
      this.tmpParameters = []
      var _this = this
      this.counterParameters.forEach(function (element) {
        if (_this.editedTaskItem.counter_parameters.includes(element.model_parameter_id)) {
          _this.tmpParameters.push(element)
        }
      })
      setTimeout(function () {
        _this.paramsLoading = false
      }, 1000)
    }
  },
  mounted () {
    if (this.$route.query.search) {
      this.search = this.$route.query.search
    }
  },
  methods: {
    getPermissionsGroupsApi () {
      this.loading = true
      this.axios.get(`/api/${API_URL}/?per_page=${this.options.itemsPerPage}&page=${this.options.page}&search=${this.search}`)
        .then((response) => {
          this.items = response.data.results
          this.serverItemsLength = response.data.count
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.firstLoading = false
          this.loading = false
        })
    },
    getPermissionsGroupsApiTimer () {
      clearTimeout(this.getTimer)
      this.getTimer = setTimeout(() => {
        this.getPermissionsGroupsApi()
      }, 100)
    },
    showErrorMessage (msg) {
      this.errorMsg = msg
      this.showError = true
      this.showErrorMsg = true
      setTimeout(() => {
        this.showError = false
      }, 4000)
      setTimeout(() => {
        this.showErrorMsg = false
      }, 4350)
    },
    deletepermissionGroupApi (item) {
      this.axios.delete(`/api/${API_URL}/${item.permissions_group_id}/`)
        .then((response) => {
          this.items.splice(
            this.items.indexOf(item), 1
          )
          clearTimeout(this.deleteTimer)
          this.deleteTimer = setTimeout(() => {
            this.items.length || this.options.page === 1 || this.options.page--
            this.getPermissionsGroupsApiTimer()
          }, 1000)
        })
        .catch((err) => {
          this.showErrorMessage(err.response.data)
          console.log(err)
        })
    },
    addPermissionsGroup () {
      this.adding = true
    },
    cancelAdding () {
      this.adding = false
    },
    permissionsGroupAdded () {
      this.getPermissionsGroupsApiTimer()
      this.adding = false
      this.showSuccess = true
      this.showSuccessMsg = true
      setTimeout(() => {
        this.showSuccess = false
      }, 3000)
      setTimeout(() => {
        this.showSuccessMsg = false
      }, 3350)
    },
    editPermissionsGroup (item) {
      this.selectedPermissionsGroupData = item
      this.editing = true
    },
    permissionsGroupEdited () {
      this.editing = false
    },
    cancelEditing () {
      this.editing = false
    },
    editPermissionsGroupError (msg) {
      this.editing = false
      this.showErrorMessage(msg)
    },
    deletePermissionsGroup (item) {
      if (confirm('Вы действительно хотите удалить данную группу?')) {
        this.deletepermissionGroupApi(item)
      }
    }
  }
}
</script>

<style lang="scss">
  .success-message {
    text-align: center;
    background-color: #56bb60;
  }
  .success-message-hide {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 0.33s, opacity 0.33s linear;
  }
  .success-message-text {
    width: 100%;
    color: white;
    font-weight: 600;
  }
  .error-message {
    text-align: center;
    background-color: #f91100;
  }
  .error-message-hide {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 0.33s, opacity 0.33s linear;
  }
  .error-message-text {
    width: 100%;
    color: white;
    font-weight: 600;
  }
  .v-card.groups-card {
    position: unset;
    > .v-btn {
      float: right;
      margin: 8px 16px;
      position: relative;
      z-index: 3;
    }
    .v-data-table {
      position: absolute;
      height: 100%;
      padding-top: 40px;
      right: 0;
      left: 0;
    }
    .v-data-table__wrapper {
      max-height: calc(100% - 59px);
    }
  }
  .action-btns {
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/spa/permissions-groups/PermissionsGroups.vue